<template>
  <div class="user-info-bar">
    <div class="user-info-logo">
      <v-img
        :src="require('@/assets/Logo-MEL-BHP-primary.png')"
        contain
        width="320"
        height="32"
      />
    </div> 
    <!-- <div class="displayInLineBlock font20" :class="mobil? 'mt-1': 'ml-1 mt-2'">
      <p class="displayInLineBlock ml-2">
        <template v-for="(txt, i) in tt">
          <span :key="i" :class="i != 0 && 'color_resaltado_1'" style="vertical-align: middle;">
            {{Array.isArray(txt) ? txt.join(' '): txt}}
          </span>
          <b v-if="i !== tt.length - 1" :key="`g${i}`" class="ml-1 mr-1" style="vertical-align: middle;">/</b>
        </template>
      </p>
    </div> -->  
    
      <table class="fontSizeBox">
        <tr>
          <td class="pr-5" style="min-width: 300px;">
            <div>{{key_position_name}}</div>
            <div>{{position_name}}</div>
          </td>
          <td class="pr-5">
            <v-btn color="primary" @click="dialog = true" small>
            <!--  style="margin-top: 0 !important; vertical-align: text-bottom;" -->
              <v-icon small>menu</v-icon>
              <span style="text-transform: none;font-size: 18px;">Menú</span>
            </v-btn>
          </td>
          <td class="pr-5">
            <notifications name="notification"  v-if="user_id"/>
          </td>
        </tr>
      </table>
      <v-dialog v-model="dialog" :width="'300px'" @click:outside="dialog = false">
        <v-card class="fullHeight pa-20">
          <template1 icon="menu" title="Menú">
            <v-icon class="closeDialog" v-on:click="dialog = false">close</v-icon>
          </template1>
          <div>
            <v-icon>format_size</v-icon>
            <div class="inset_div" :class="dark_t?'dark':''">
              <v-icon class="desk" :disabled="fontSize > 28" @click.stop="$store.dispatch('fontSizeMore')">add</v-icon>
              <v-icon class="desk" :disabled="fontSize < 10" @click.stop="$store.dispatch('fontSizeLess')">remove</v-icon>
            </div>
            <fs1-span style="padding-left:10px">Tamaño fuente:{{$store.getters.fontSize}}</fs1-span>
          </div>
          <div>
            <v-switch
              style="opacity:1"
              v-model="dark_c"
              :label="`Vista ${$vuetify.theme.dark?'clara':'oscura'}`"
              ligth
              color="secondary"
              hide-details></v-switch>
          </div>
          <div style="margin-top:100px">
            <v-btn color="primary"  @click="logout" :width="'100%'">
              <v-icon style="position:absolute;left:0;">vpn_key</v-icon>
              <span>Cerrar sesión</span>
            </v-btn>
          </div>

        </v-card>
      </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { patch_function_dark_mode } from '@/requests/ac';
import { FRONTEND_V2 } from '@/config';
import notifications from './notifications.vue';
const f1 = (lista, item) => lista.unshift(item.text) && item.parent && f1(lista, item.parent);

export default {
  components: {notifications},
  data(){
    return {
      dialog:false,
      userPositionIds:[],
      /* selectEnterpriseDialog: true, */
      $router: this.$router,
      menu: [
        {title:'toogle_dark_theme', event: 'toogle_dark_theme'},
        {title:'Cambio de rol'},
        {title:'Cambio de empresa', event: 'selectE'},
        {title:'Cambio de contraseña'},
        {title:'Salir', event: 'logout'},
      ]
    }
  },
  computed: {
    ...mapGetters({
      menuLateral: 'menuLateral',
      menuLateralIndice: 'menuLateralIndice',
      selectedEnterprise: 'selectedEnterprise',
      fontSize:'fontSize',
    }),
    /* userPosition() { return this.$user.position_name }, */
    employee_name() { return this.session.user? this.session.user.employee_name: '' },
    key_position_name() { return this.session.user? this.session.user.key_position_name: ''},
    position_name() { return this.session.user? this.session.user.position_name: ''},

    activeRouterName(){ return this.$router.currentRoute.name },
    fullName() { return `${this.$user.first_name} ${this.$user.last_name}` },
    menuActive() { return this.menuLateralIndice[this.activeRouterName] },
    tt() {
      this.dev_log(this.menuActive,this.menuLateralIndice,`activeRouterName: ${this.activeRouterName}`)
      const lista = [];
      return this.menuActive
        ? f1(lista,this.menuActive) || lista
        : ['No encontrado'];
    },
    dark_theme(){
      return this.$vuetify.theme.dark
    },
    dark_c: {
      // getter
      get: function () {
        const {dark} = this.$store.getters;
        this.$vuetify.theme.dark = dark;
        this.$vuetify.theme.secondary = dark ? '#bfbfbf' :'#424242';
        return dark
      },
      // setter
      set: function (val) {
        this.$store.dispatch('set', {key: 'dark', val});
        this.patch_function_dark_mode(val);
        this.$vuetify.theme.dark = val;
      }
    },
  },
  methods: {
    menuMethods(name){ this[name] ? this[name]() : console.warn(`no existe metodo ${name}`) },
    logout(){
      this.$store.dispatch('logout');
      localStorage.clear();
      window.location.href = `${FRONTEND_V2}/logout?source=ac`;
    },
    toogle_dark_theme(){ this.$vuetify.theme.dark = !this.dark_theme },
    async patch_function_dark_mode(dark_mode){
      if(!await this.assignAccess()) return this.getError('assignAccess');
      patch_function_dark_mode({dark_mode});
    }
  }
};
</script>

<style scoped>
.user-info-bar {
  color: white;
  height: 60px;
  display: flex;
  align-items: center;
  padding-left: 20px;
}
.user-info-logo {
  flex: 0 0 auto;
  line-height: 0;
}
.inset_div{
  background-color: #e0e0e0;
  display: inline-block;
  border-radius: 50px;
  padding: 2px;
  margin-left: 5px;
}
.inset_div.dark{ background-color: #a5a5a5 }
.fontSizeBox{
  font-size: 13px;
  font-weight: bold;
  margin-left: auto;
}
.mt-10 { margin-top: 10px; }
.escondida {
  width: 260px;
  height: 60px;
  padding: 0;
  margin: 0;
}
.logout{
  cursor: pointer;
  background: #e65100;
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 6px;
  padding-bottom: 6px;
  vertical-align: top;
  text-transform: uppercase;
  border-radius: 2px;
}
</style>
